import React from 'react';
import { IconProps } from '../../../DefaultIcon';

export function GeneralIcon({ className }: IconProps) {
  return (
    <svg
      width="76"
      height="76"
      viewBox="0 0 76 76"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_973)">
        <path
          d="M38.0004 76C37.2418 76 36.6211 75.3793 36.6211 74.6207V1.37931C36.6211 0.62069 37.2418 0 38.0004 0C38.759 0 39.3797 0.62069 39.3797 1.37931V74.5977C39.3797 75.3563 38.759 75.977 38.0004 75.977"
          fill="#00C4B3"
        />
        <path
          d="M13.8165 76.0002C13.6326 76.0002 13.4487 75.9542 13.2648 75.8852C12.5752 75.5864 12.2533 74.7588 12.5522 74.0691L36.7361 19.4255C37.0349 18.7358 37.8625 18.414 38.5522 18.7128C39.2418 19.0346 39.5637 19.8392 39.2648 20.5289L15.0809 75.1726C14.851 75.6783 14.3453 76.0002 13.8165 76.0002Z"
          fill="#00C4B3"
        />
        <path
          d="M62.1835 76.0001C61.6548 76.0001 61.149 75.7013 60.9191 75.1725L36.7352 20.5289C36.4364 19.8392 36.7352 19.0116 37.4479 18.7128C38.1375 18.4139 38.9651 18.7128 39.264 19.4254L63.4479 74.0461C63.7697 74.7358 63.4479 75.5633 62.7352 75.8622C62.5513 75.9312 62.3674 75.9771 62.1835 75.9771"
          fill="#00C4B3"
        />
        <path
          d="M74.2533 8.64355H1.72461V60.4596H74.2533V8.64355Z"
          fill="#EAEDF8"
        />
        <path
          d="M75.3103 5.17236H0.689655C0.298851 5.17236 0 5.4942 0 5.86202V7.93098C0 8.32179 0.298851 8.62064 0.689655 8.62064H75.3103C75.7011 8.62064 76 8.2988 76 7.93098V5.86202C76 5.47121 75.6782 5.17236 75.3103 5.17236Z"
          fill="#00C4B3"
        />
        <path
          d="M75.3103 60.46H0.689655C0.298851 60.46 0 60.7818 0 61.1496V63.2186C0 63.6094 0.298851 63.9082 0.689655 63.9082H75.3103C75.7011 63.9082 76 63.6094 76 63.2186V61.1496C76 60.7588 75.6782 60.46 75.3103 60.46Z"
          fill="#00C4B3"
        />
        <path
          d="M12.0918 34.5515C12.0918 39.7929 14.2067 44.5515 17.655 47.9768L31.0803 34.5515V15.54C20.5975 15.54 12.0918 24.0458 12.0918 34.5285"
          fill="#D6DBE7"
        />
        <path
          d="M44.5288 21.1035L31.1035 34.5288L44.5288 47.9541C47.9771 44.5058 50.092 39.7702 50.092 34.5288C50.092 29.2874 47.9771 24.5288 44.5288 21.1035Z"
          fill="#FAFBFD"
        />
        <path
          d="M31.0801 15.54V34.5285L44.5054 21.1033C41.0571 17.678 36.3215 15.54 31.0801 15.54Z"
          fill="#00416B"
        />
        <path
          d="M17.6553 47.977C21.0806 51.4253 25.8392 53.5403 31.0806 53.5403C36.3219 53.5403 41.0806 51.4253 44.5058 47.977L31.0806 34.5518L17.6553 47.977Z"
          fill="#00C4B3"
        />
        <path
          d="M38.6895 34.5516C38.6895 30.3447 35.2872 26.9424 31.0803 26.9424C26.8735 26.9424 23.4941 30.3447 23.4941 34.5516C23.4941 38.7585 26.8964 42.1608 31.0803 42.1608C35.2643 42.1608 38.6895 38.7585 38.6895 34.5516Z"
          fill="#EAEDF8"
        />
        <path
          d="M44.2063 27.9768C44.0223 27.9768 43.8614 27.9078 43.7235 27.7699C43.4476 27.4941 43.4476 27.0573 43.7235 26.8044L48.2063 22.3216C48.3442 22.1837 48.5051 22.1147 48.689 22.1147H63.1948C63.5856 22.1147 63.8844 22.4366 63.8844 22.8044C63.8844 23.1722 63.5856 23.4941 63.1948 23.4941H48.9649L44.689 27.7929C44.5511 27.9308 44.3672 27.9998 44.2063 27.9998"
          fill="#00416B"
        />
        <path
          d="M63.2183 15.1952H58.7356C58.3447 15.1952 58.0459 14.8964 58.0459 14.5056C58.0459 14.1148 58.3447 13.8159 58.7356 13.8159H63.2183C63.6091 13.8159 63.908 14.1148 63.908 14.5056C63.908 14.8964 63.6091 15.1952 63.2183 15.1952Z"
          fill="#00416B"
        />
        <path
          d="M55.2638 15.1952H47.3098C46.919 15.1952 46.6201 14.8964 46.6201 14.5056C46.6201 14.1148 46.919 13.8159 47.3098 13.8159H55.2638C55.6546 13.8159 55.9534 14.1148 55.9534 14.5056C55.9534 14.8964 55.6546 15.1952 55.2638 15.1952Z"
          fill="#00416B"
        />
        <path
          d="M63.2183 19.3329H47.3332C46.9424 19.3329 46.6436 19.0341 46.6436 18.6433C46.6436 18.2525 46.9424 17.9536 47.3332 17.9536H63.2183C63.6091 17.9536 63.9079 18.2755 63.9079 18.6433C63.9079 19.0111 63.6091 19.3329 63.2183 19.3329Z"
          fill="#00416B"
        />
        <path
          d="M63.2185 55.2644H45.9542C45.7703 55.2644 45.5864 55.1955 45.4714 55.0575L39.2645 48.8506C38.9887 48.5748 38.9887 48.138 39.2645 47.8851C39.5404 47.6093 39.9772 47.6093 40.253 47.8851L46.276 53.9081H63.2645C63.6553 53.9081 63.9542 54.2299 63.9542 54.5978C63.9542 54.9656 63.6553 55.2874 63.2645 55.2874"
          fill="#00416B"
        />
        <path
          d="M63.2182 46.9882H50.7815C50.3906 46.9882 50.0918 46.6893 50.0918 46.2985C50.0918 45.9077 50.3906 45.6089 50.7815 45.6089H63.2182C63.609 45.6089 63.9079 45.9077 63.9079 46.2985C63.9079 46.6893 63.609 46.9882 63.2182 46.9882Z"
          fill="#00416B"
        />
        <path
          d="M59.4017 51.1264H50.758C50.3672 51.1264 50.0684 50.8275 50.0684 50.4367C50.0684 50.0459 50.3672 49.7471 50.758 49.7471H59.4017C59.7925 49.7471 60.0913 50.0689 60.0913 50.4367C60.0913 50.8045 59.7925 51.1264 59.4017 51.1264Z"
          fill="#00416B"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_973">
          <rect width="76" height="76" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
